import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import CreateIcon from "../../Icons/CreateIcon";
import {
  createAuthorSchema,
  IAuthorSchema,
} from "../../utils/validationSchema";
import EditAuthorForm from "./AuthorForm";

const EditAuthor = (props: any) => {
  const { handleEdit, isLoading, data } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IAuthorSchema>({
    defaultValues: async () => ({
      display_name: data?.display_name,
      user: data?.user,
      preview_image: data?.preview_image,
      summery: data?.summery,
    }),
    resolver: yupResolver(createAuthorSchema),
  });

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Author
        </span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleEdit}
        setError={setError}
        buttonLabel={"Update"}
        isLoading={isLoading}
      >
        <EditAuthorForm
          clearErrors={clearErrors}
          errors={errors}
          register={register}
          setValue={setValue}
          getValues={getValues}
          control={control}
        />
      </FormLayout>
    </>
  );
};

export default EditAuthor;
